import cn from 'classnames'

export type PillProps = {
  children: string
  muted?: boolean
}

export const Pill = ({children, muted = false}: PillProps) => (
  <span
    className={cn(
      'inline-flex items-center whitespace-nowrap rounded-full border px-3 py-1 text-[11px] uppercase tracking-[0.04em]',
      muted ? 'border-moss-white/10 text-green-mist-dim' : 'border-green-neon/45 text-green-neon',
    )}
  >
    {children}
  </span>
)
